function GiftFinderPOC(){
    return(
        <>
        <div>Gift finder</div>
        <div id="gift-finder-content"></div>
        </>
    )
}

export default GiftFinderPOC;